import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiLogin } from "@/lib/api";
import { Lock, Mail } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiLogin(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-midnight hero-radial">
      <Toaster theme="dark" position="top-right" />
      <form onSubmit={submit} className="glass-strong p-10 w-full max-w-md mx-4" data-testid="admin-login-form">
        <div className="eyebrow mb-3">CMS · Admin</div>
        <h1 className="font-display text-4xl text-ivory">Sign in</h1>
        <p className="mt-2 text-sm text-ivory/55">Manage the Geomantic Kalpataru content.</p>

        <div className="mt-8 grid gap-5">
          <div className="grid gap-2">
            <label className="text-xs uppercase tracking-[0.25em] text-ivory/55">Email</label>
            <div className="flex items-center gap-3 border border-gold/25 bg-midnight/60 px-4 py-3 focus-within:border-gold transition">
              <Mail className="h-4 w-4 text-gold" />
              <input
                data-testid="admin-login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-transparent flex-1 text-ivory outline-none"
                placeholder="you@example.com"
              />
            </div>
          </div>
          <div className="grid gap-2">
            <label className="text-xs uppercase tracking-[0.25em] text-ivory/55">Password</label>
            <div className="flex items-center gap-3 border border-gold/25 bg-midnight/60 px-4 py-3 focus-within:border-gold transition">
              <Lock className="h-4 w-4 text-gold" />
              <input
                data-testid="admin-login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-transparent flex-1 text-ivory outline-none"
                placeholder="••••••••"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="btn-gold mt-2 justify-center disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
